// extracted by mini-css-extract-plugin
export default {"checkbox-wrapper":"checkbox_checkbox-wrapper__NdcKl","checkbox":"checkbox_checkbox__-rPBX","label":"checkbox_label__Yk7A9","checked":"checkbox_checked__Lg1Y5"};